import { render, staticRenderFns } from "./TotalStats.container.vue?vue&type=template&id=b7ffe98c&scoped=true&"
import script from "./TotalStats.container.vue?vue&type=script&lang=js&"
export * from "./TotalStats.container.vue?vue&type=script&lang=js&"
import style0 from "./TotalStats.container.vue?vue&type=style&index=0&id=b7ffe98c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ffe98c",
  null
  
)

export default component.exports